<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
        <form [formGroup]="appointmentForm" (ngSubmit)="onSave()">
            <h1 *ngIf="source !== 'modal'" class="heading">
                {{appointmentId ? 'Edit' : 'Add'}}
            </h1>
            <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2">

                <!-- title -->
                <div class="space-y-1">
                    <label class="subheading">
                        Title <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="title" />
                        </div>
                    </div>
                    <div *ngIf="form.title.errors && submitted">
                        <div *ngIf="form.title.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Title is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- status -->
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <select formControlName="isActive">
                                <option [value]="true">Active</option>
                                <option [value]="false">Inactive</option>
                            </select>
                        </div>
                    </div>
                    <div *ngIf="form.isActive.errors && submitted">
                        <div *ngIf="form.isActive.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Status is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Description -->
                <div class="space-y-1">
                    <label class="subheading">
                        Description <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <textarea type="text" formControlName="description"></textarea>
                        </div>
                    </div>
                    <div *ngIf="form.description.errors && submitted">
                        <div *ngIf="form.description.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Description is required
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{appointmentId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>